// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { checkoutShippingCarrierServiceStyles } from "@eisinc/Overrides/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitCarrierService";
import QuestionCircle from "@eisinc/XDL/Icons/QuestionCircle";
import { fontConfig } from "@eisinc/XDL/PreStyle/typography";
import { color, createLinkIconStyles, xScreen } from "@eisinc/XDL/Utilities";
import PlusCircle from "@insite/mobius/Icons/PlusCircle";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

checkoutShippingCarrierServiceStyles.innerContainer = {
    css: css`
        padding-bottom: 16px;
        border-bottom: 1px solid ${color("common.ui3")};
        &:not(.no-space) {
            margin-bottom: 16px;
        }

        &.innerContainer:last-of-type {
            border-bottom: none;
            padding-bottom: 0;
            margin-bottom: 0;
        }
    `,
};

checkoutShippingCarrierServiceStyles.headingText = {
    variant: "h4",
    css: css`
        margin-bottom: 12px;
    `,
};

checkoutShippingCarrierServiceStyles.shippingMethodContainer = {
    css: css`
        display: flex;
        gap: 24px 22px;
        ${xScreen("lt", "lg")} {
            flex-direction: column;
        }
    `,
};

checkoutShippingCarrierServiceStyles.carrierAccountField = {
    cssOverrides: {
        formField: css`
            margin-top: 8px;
            padding-left: 20px;
            max-width: 190px;
            ${xScreen("lt", "lg")} {
                max-width: 100%;
            }
        `,
    },
};

checkoutShippingCarrierServiceStyles.additionalDetailsField = {
    cssOverrides: {
        formField: css`
            margin-top: 8px;
            padding-left: 20px;
            max-width: 190px;
            ${xScreen("lt", "lg")} {
                max-width: 100%;
            }
        `,
    },
};

checkoutShippingCarrierServiceStyles.radioTextFieldWrapper = {
    css: css`
        &,
        & + div[class^="RadioStyle"] {
            margin-top: 12px;
        }
    `,
};

checkoutShippingCarrierServiceStyles.radioGroup = {
    labelProps: {
        size: fontConfig.singleLinexSmall.size,
        lineHeight: fontConfig.singleLinexSmall.lineHeight,
        weight: fontConfig.weight.medium,
    },
};

checkoutShippingCarrierServiceStyles.shipmentRadioGroup = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        row-gap: 12px;
    `,
};

checkoutShippingCarrierServiceStyles.carrierContainer = {
    css: css`
        width: 100%;
        max-width: 317px;
        ${xScreen("lt", "lg")} {
            max-width: 100%;
        }
    `,
};

checkoutShippingCarrierServiceStyles.serviceContainer = {
    css: css`
        width: 100%;
        max-width: 317px;
        ${xScreen("lt", "lg")} {
            max-width: 100%;
        }
    `,
};

checkoutShippingCarrierServiceStyles.noteWrapper = {
    css: css`
        width: 100%;
        max-width: 317px;
        display: grid;
        gap: 15px;

        ${xScreen("lt", "lg")} {
            max-width: 100%;
        }
    `,
};

checkoutShippingCarrierServiceStyles.deliveryDateWrapper = {
    css: css`
        display: grid;
        grid-template-columns: 1fr;
        gap: 16px;

        & .datePicker-container {
            display: flex;
        }
    `,
};

checkoutShippingCarrierServiceStyles.deliveryDateMessage = {
    size: fontConfig.singleLineSmall.size,
    lineHeight: fontConfig.singleLineSmall.lineHeight,
    css: css`
        margin-bottom: 0;
        max-width: 882px;
        & > ${TypographyStyle} {
            color: inherit;
            font-size: inherit;
            font-weight: inherit;
            line-height: inherit;
            margin-bottom: 0;
        }
    `,
};

checkoutShippingCarrierServiceStyles.deliveryDatePicker = {
    cssOverrides: {
        formField: css`
            max-width: 204px;
        `,
    },
};

checkoutShippingCarrierServiceStyles.wholeOrderWrapper = {
    css: css`
        display: flex;
    `,
};

checkoutShippingCarrierServiceStyles.sectionWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        row-gap: 16px;
    `,
};

checkoutShippingCarrierServiceStyles.shipmentRadio = {
    css: css`
        border: 1px solid ${color("common.ui4")};
        padding: 8px;
        line-height: ${fontConfig.singleLinexSmall.lineHeight};
        display: flex;
        align-items: center;
        &.checked {
            border-color: ${color("primary")};
            background: ${color("common.ui2")};
        }
    `,
};
checkoutShippingCarrierServiceStyles.selectedShipmentRadio = {
    css: css`
        border: 1px solid ${color("primary")};
        padding: 8px;
        line-height: ${fontConfig.singleLinexSmall.lineHeight};
        background: ${color("common.ui2")};
        display: flex;
        align-items: center;
    `,
};

checkoutShippingCarrierServiceStyles.shippingCostLabel = {
    ...fontConfig.singleLinexSmall,
    weight: fontConfig.weight.medium,
    css: css`
        display: block;
        margin-bottom: 12px;
    `,
};

checkoutShippingCarrierServiceStyles.dateCell = {
    css: css`
        &,
        ${TypographyStyle} {
            font-size: ${fontConfig.singleLinexSmall.size}px;
            line-height: ${fontConfig.singleLinexSmall.lineHeight};
            font-weight: ${fontConfig.weight.medium};
        }
    `,
};
checkoutShippingCarrierServiceStyles.amountCell = {
    css: css`
        &,
        ${TypographyStyle} {
            font-size: ${fontConfig.singleLinexSmall.size}px;
            line-height: ${fontConfig.singleLinexSmall.lineHeight};
        }
    `,
};
checkoutShippingCarrierServiceStyles.shippingCostBreakdownWrapper = {
    css: css`
        width: 100%;
        max-width: 317px;
        ${xScreen("lt", "lg")} {
            max-width: 100%;
        }
    `,
};

checkoutShippingCarrierServiceStyles.requestCertificationsWrapper = {
    css: css`
        margin-top: 4px;
    `,
};

checkoutShippingCarrierServiceStyles.requestCertificationsLink = {
    ...createLinkIconStyles({
        icon: PlusCircle,
        sizeVariant: "medium",
        linkStyles: {
            typographyProps: { weight: fontConfig.weight.medium },
        },
    }),
};

checkoutShippingCarrierServiceStyles.requestCertificationsTooltip = {
    iconProps: { src: QuestionCircle, ...{ width: 14, height: 14 }, color: "primary" },
};
